<ng-container *transloco="let t" class="container">
    <form [formGroup]="inputForm">
        <div class="modal-body">
            <div class="d-flex align-items-center pb-4">
                <img src="assets/img/svg/T.svg" alt="Tracey logo">
                <div class="d-flex align-items-start flex-grow-1">
                    <div class="fw-semibold title-wrapper line-height-1">
                        {{ t("race.management.competitors.confirm.registration.dialog.title") }}
                    </div>
                </div>
                <div class="pe-20 d-flex">
                    <button type="button" class="btn-close" aria-label="Close"
                            (click)="activeModal.dismiss('Cross click')"></button>
                </div>
            </div>
            <div class="body-wrapper">
                <div class="row">
                    <div class="col-12 pt-20-10">
                        <app-select
                                formControlName="amountStatus"
                                [displaySelectionAsBadge]="true"
                                [items]="items"
                                [labels]="itemLabels"
                                [badgeClasses]="['green', 'red-green','orange']"
                                label="competitor.management.payment.status">
                        </app-select>
                    </div>
                    <div class="col-12 pt-20-10">
                        <app-textarea
                                id="note"
                                formControlName="note"
                                rows="5"
                                label="competitor.management.payment.comment">
                        </app-textarea>
                    </div>
                    @if (inputForm.controls.amountStatus.value === AmountStatus.EXACT || inputForm.controls.amountStatus.value === AmountStatus.OVERPAID) {
                    <div class="col-12 pt-20-10">
                        <div class="pb-20 pt-20 fst-italic">
                            <span>
                                {{t("race.management.competitors.confirm.registration.dialog.text")}}
                            </span>
                           </div>
                     </div>
                    }

                </div>
            </div>

            <div class="d-flex justify-content-center align-items-center pb-40-48">
                <div class="d-flex">
                    <div class="pe-3">
                        <app-rounded-button [label]="t('app.common.cancel')"
                                            [btnClass]="'btn-grey text-uppercase'" (onClick)="onDismissClick()"/>
                    </div>
                    <app-rounded-button [label]="t('app.common.confirm')" (onClick)="onConfirmClick()"
                                        [btnClass]="'btn-primary-red text-uppercase'"></app-rounded-button>
                </div>
            </div>
        </div>
    </form>
</ng-container>
